import axios from 'axios';

export function adminRejectCampaignContent(adId, payload, token) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/admin/advertisements/${adId}/reject-content`,
        payload || {},
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
